// extracted by mini-css-extract-plugin
export default {"logo":"HomeLogo_logo__b1RNl"};